import { render, staticRenderFns } from "./addTemplateView.vue?vue&type=template&id=edf4778a&scoped=true"
import script from "./addTemplateView.vue?vue&type=script&lang=js"
export * from "./addTemplateView.vue?vue&type=script&lang=js"
import style0 from "./addTemplateView.vue?vue&type=style&index=0&id=edf4778a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf4778a",
  null
  
)

export default component.exports